import React, { useEffect, useRef, useState } from 'react'
import topIconSetDark from '../../../../../src/assets/images/app_header_iconset_dark.png';
import userImg2 from '../../../../../src/assets/images/lumi_img2.png'
import prevArrow from '../../../../../src/assets/images/prevArrow.png'
import decor from '../../../../../src/assets/images/lumi_decor.png'
import contactIcon from '../../../../../src/assets/images/contact_icon_white.png'
import connectButton from '../../../../../src/assets/images/app_connect_btn.png'
import sliderdotImage from '../../../../../src/assets/images/slider_dot_img.png'
import { Spin } from 'antd/lib';
import DateService from '../../../../Services/DateService';

const ListingView = ({ children, currentTime, data = [], className }) => {

    let [parent, child] = [useRef(), useRef()]
    const [scrollArrowVisible, setScrollArrowVisible] = useState(false)

    useEffect(() => {
        if (parent.current && child.current) {
            const parentHeight = parent.current.offsetHeight;
            const childHeight = child.current.offsetHeight;
            setScrollArrowVisible(childHeight + 50 < parentHeight)
        }
    }, [parent, child]);
    return (
        <>
            {
                !data.length ? (
                    <div className="spinner center">
                        <Spin />
                    </div>
                ) : (
                    <div className={`app`} ref={parent}>
                        <div className={`listing_view ${className} ${scrollArrowVisible && 'scrollable_arrow'} `} ref={child}>
                            <header className="app__header transparent">
                                <div className="app__header__top">
                                    <span className="app__header__top__time dark">{currentTime}</span>
                                    <div className="app__header__top__icons">
                                        <img src={topIconSetDark} alt="" />
                                    </div>
                                </div>
                            </header>
                            <main className="app__main" style={{ paddingTop: 0 }}>
                                <div className="app__matches-container">
                                    <div className="app__header transparent app__header___top">
                                        <div className="app__back-button">
                                            <img src={prevArrow} alt="" />
                                        </div>
                                        <div className="app__title">Matches</div>
                                        <div className="app__heart-button">
                                            <img src={decor} alt="" />
                                        </div>
                                    </div>
                                    <div className="app__matches-list">
                                        {data.map((match, index) => (
                                            <React.Fragment key={index}>
                                                {match._id && (
                                                    <React.Fragment>
                                                        {index === 1 && (
                                                            <div className="app__match-card">
                                                                {children ? children : 'no data to show'}
                                                            </div>
                                                        )}
                                                        <div className="app__match-card">
                                                            <div className="app__match-image">
                                                                {match.profile_images && match.profile_images.length > 0 ? (
                                                                    match.profile_images.map((el, idx) => (
                                                                        <img className='cover' key={idx} src={el.original} alt={`Profile image ${idx}`} />
                                                                    ))
                                                                ) : (
                                                                    <span>No profile images added</span>
                                                                )}
                                                                <span className='app__contact_icon'>
                                                                    <img src={contactIcon} alt="contact icon" />
                                                                </span>
                                                            </div>
                                                            <div className="app__match-info">
                                                                <div className="app__match-id">{match.lumi_id}</div>
                                                                <div className="app__match-name">{match.name}</div>
                                                                <div className="app__match-details">
                                                                    <div className='app__info_wrap'>
                                                                        <div className="app__match-age">{match.age} yrs</div>
                                                                        <span className="divider text_red">|</span>
                                                                        <div className="app__match-height">{match.height?.label}</div>
                                                                        <span className="divider text_red">|</span>
                                                                        <div className="app__match-status">{match.marital_status?.label}</div>
                                                                    </div>
                                                                    <div className="app__match-religion">{match.religion?.label}</div>
                                                                    <div className="app__match-profession">{match.job?.label}</div>
                                                                    <div className="app__match-location">{match.city?.label}</div>
                                                                    <div className="app__match-connect">
                                                                        <img src={connectButton} alt="connect button" />
                                                                    </div>
                                                                    <span className='slider_dot'>
                                                                        <img src={sliderdotImage} alt="slider dot" />
                                                                    </span>
                                                                </div>
                                                                <div className="app__match-last-online">
                                                                    Last online: {DateService.formatDateCustom(match.last_login)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </div>

                                </div>
                            </main>
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default ListingView
